import {Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'yo-svg',
  templateUrl: 'svg.component.html',
  styleUrls: ['./svg.component.scss'],
  standalone: false
})
export class SvgComponent implements OnInit {

  @Input() src!: string;
  @Input() colors: {index: number, color: string}[] = [];

  constructor(
    private http: HttpClient,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (this.src) {
      this.loadSvg(this.src);
    }
  }

  private loadSvg(url: string) {
    this.http.get(url, { responseType: 'text' })
      .subscribe(svgText => {

        this.elementRef.nativeElement.innerHTML = '';

        const parser: DOMParser = new DOMParser();
        const svgDoc: Document = parser.parseFromString(svgText, 'image/svg+xml');
        const svgElement: HTMLElement = svgDoc.documentElement;

        this.renderer.appendChild(this.elementRef.nativeElement, svgElement);
        svgElement.classList.add('icon-base', 'custom-svg');

        this.colors.forEach((kvp : {index: number, color: string}): void => {
          svgElement.style.setProperty('--svg-color-' + kvp.index, kvp.color);
        });
      }, error => {
        console.error('Erreur de chargement du SVG:', error);
      });
  }
}
